import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UniqueChangeDetectorCharacterPipe } from './unique-change-detector-character.pipe';

@NgModule({
  declarations: [UniqueChangeDetectorCharacterPipe],
  imports: [CommonModule],
  exports: [UniqueChangeDetectorCharacterPipe],
})
export class UniqueChangeDetectorCharacterModule {}
